import React from 'react';

import TeaserContainer from '../organisms/teaser-container/teaserContainer';
import ThinkingSpaceCluster from '../organisms/thinking-space-cluster/thinkingSpaceCluster';
import HeroTeaser from '../molecules/hero-teaser/heroTeaser';
import CurrentInfo from '../molecules/current-info/currentInfo';
import LivestreamTeaser from '../molecules/livestream-teaser/livestreamTeaser';
import PdfViewer from '../organisms/pdf-viewer/pdfViewer';

const getPageModule = (block, index) => {
  console.dir(block.data);

  return {
    currentInfo: <CurrentInfo {...block.data} key={index} />,
    standardTeaserContainer: <TeaserContainer data={block.data} key={index} />,
    teaserList: <TeaserContainer data={block.data} key={index} />,
    customTeaserContainer: <TeaserContainer data={block.data} key={index} />,
    heroTeaser: <HeroTeaser {...block.data} key={index} />,
    livestreamTeaser: <LivestreamTeaser {...block.data} key={index} />,
    thinkingSpaceCluster: <ThinkingSpaceCluster {...block.data} />,
    pdfViewer: <PdfViewer {...block.data} key={index} />
  };
};

export default getPageModule;
